import {
  CLEAR_TOOLS_RBI_CUSTOMER_STORE,
  CLEAR_TOOLS_RBI_STORE,
  SET_RBI_CUSTOMER_INFO,
  SET_RBI_GIFT_CARD_TRANSFER,
} from '../../../actions/types';

const rbi = (state = {}, action) => {
  switch (action.type) {
    case SET_RBI_CUSTOMER_INFO:
      return Object.assign({}, state, action.customer);
    case SET_RBI_GIFT_CARD_TRANSFER:
      return Object.assign({}, state, action.transaction);
    case CLEAR_TOOLS_RBI_STORE:
      return Object.assign({}, state, {
        customer: {},
        transaction: {},
      });
    case CLEAR_TOOLS_RBI_CUSTOMER_STORE:
      return Object.assign({}, state, {
        customer: {},
      });
    default:
      return state;
  }
};

export default rbi;
